module.exports = __webpack_public_path__ + "7242ab75421860dba32d06c206ab66e3.png";